import { Image } from 'react-bootstrap';
import './style.css';

import wolff_logo from '../../images/companies-logos/wolff.webp';
import lyor_logo from '../../images/companies-logos/lyor.webp';
import bohemia_logo from '../../images/companies-logos/bohemia.webp';
import royal_image from '../../images/companies-logos/royal.webp';
import woodart_logo from '../../images/companies-logos/woodart.webp';
import bon_gourmet_logo from '../../images/companies-logos/bon_gourmet.webp';
import casa_limpa_logo from '../../images/companies-logos/casa_limpa.jpg';
import house_logo from '../../images/companies-logos/house.jpg';
import arcopal_logo from '../../images/companies-logos/arcopal.jpg';
import caldier_logo from '../../images/companies-logos/caldier.webp';
import dekorcam_logo from '../../images/companies-logos/dekorcam.jpg';
import luminarc_logo from '../../images/companies-logos/luminarc.jpg';
import rona_logo from '../../images/companies-logos/rona.webp';

const LogosComponent = () => {
  return (
    <div className='companies-download'>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/WOLFF-imagens.zip'
      >
        <Image
          className='logo wolff-logo'
          src={`${wolff_logo}`}
          thumbnail
          width='260px'
        />
      </a>
	  <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/LYOR-imagens.zip'
      >
        <Image
          className='logo lyor-logo'
          src={`${lyor_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/WOODART-imagens.zip'
      >
        <Image
          className='logo woodart-logo'
          src={`${woodart_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/BON_GOURMET-imagens.zip'
      >
        <Image
          className='logo bon-gourmet-logo'
          src={`${bon_gourmet_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/ROYAL-imagens.zip'
      >
        <Image
          className='logo royal-image'
          src={`${royal_image}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/BOHEMIA-imagens.zip'
      >
        <Image
          className='logo bohemia-logo'
          src={`${bohemia_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/CALDIER-imagens.zip'
      >
        <Image
          className='logo caldier-logo'
          src={`${caldier_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/RONA-imagens.zip'
      >
        <Image
          className='logo rona-logo'
          src={`${rona_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/HOUSE-imagens.zip'
      >
        <Image
          className='logo house-logo'
          src={`${house_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/casa_limpa-imagens.zip'
      >
        <Image
          className='logo casa-limpa-logo'
          src={`${casa_limpa_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/LUMINARC-imagens.zip'
      >
        <Image
          className='logo luminarc-logo'
          src={`${luminarc_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/arcopal-imagens.zip'
      >
        <Image
          className='logo arcopal-logo'
          src={`${arcopal_logo}`}
          thumbnail
          width='260px'
        />
      </a>
      <a
        rel='noreferrer'
        href='http://gruporojemac.dnsalias.com:3055/zipped/DEKOR_CAM-imagens.zip'
      >
        <Image
          className='logo dekorcam-logo'
          src={`${dekorcam_logo}`}
          thumbnail
          width='260px'
        />
      </a>
    </div>
  );
};

export default LogosComponent;
